// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.destinations {
  /* min-height: 200vh; */
  /* padding-bottom: 7em; */
}

.destinations__result h2 {
  font-size: 1.1rem;
  color: var(--clr-gray800);
  white-space: nowrap;
}

.destinations__resultContainer {
  margin-top: 2rem;
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
}

.destinations__resultCard {
  position: relative;
  border-radius: 1em;
  overflow: hidden;
  height: 10rem;
  cursor: pointer;

  z-index: -1;
  /* max-height: 20rem; */
}

.destinations__resultCard img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.destinations__titleResultCard {
  position: absolute;
  color: var(--clr-light);
  background: var(--clr-primary);
  padding: 1em;
  font-size: 0.9rem;
  letter-spacing: 0.075rem;
  border-radius: 1em;
  left: 1rem;
  top: 1rem;
}

.destinations__priceResultCard {
  display: flex;
  align-items: center;
  padding: 0.5em 1em;
  position: absolute;
  left: 1rem;
  color: var(--clr-light);
  bottom: 1rem;
  border: 2px solid transparent;
  -webkit-font-smoothing: antialiased;
  background-clip: padding-box;
  font-size: 0.9rem;
  -moz-osx-font-smoothing: grayscale;
  background: rgb(20, 20, 43, 0.4);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  letter-spacing: 0.075rem;
  border-radius: 1em;
}

.destinations__priceResultCard img {
  margin-right: 0.5rem;
  display: block;
  max-width: 1.5rem;
}

.destinations__resultBtn {
  /* padding: 1em; */
  margin: 3rem auto 0 auto;
  border-radius: 1em;
  padding: 1.25em 1.75em;
}

.destinations__resultBtn svg {
  width: 1.5rem;
  margin-right: 0.5rem;
}

@media (min-width: 375px) {
  .destinations__result h2 {
    font-size: 1.25rem;
  }
}

@media (min-width: 768px) {
  .destinations__result {
    padding-top: 5rem;
  }

  .destinations__resultCard {
    height: 12rem;
  }

  .destinations__result h2 {
    font-size: 2rem;
  }
}

@media (min-width: 992px) {
  .destinations__resultCard:nth-of-type(11n + 7),
  .destinations__resultCard:nth-of-type(11n + 6),
  .destinations__resultCard:nth-of-type(11n + 3),
  .destinations__resultCard:nth-of-type(11n + 2) {
    grid-column: span 2;
  }
}

@media (min-width: 1200px) {
  .destinations__result {
    padding-top: 2rem;
  }

  .destinations__resultCard {
    height: 15rem;
  }

  .destinations__resultCard:nth-of-type(11n + 10),
  .destinations__resultCard:nth-of-type(11n + 6),
  .destinations__resultCard:nth-of-type(11n + 4),
  .destinations__resultCard:nth-of-type(11n + 1),
  .destinations__resultCard:nth-of-type(11n + 2) {
    grid-column: span 2;
  }

  .destinations__resultCard:nth-of-type(11n + 3),
  .destinations__resultCard:nth-of-type(11n + 7) {
    grid-column: span 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Destinations/Destinations.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;;EAEf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;EAC5B,iBAAiB;EACjB,kCAAkC;EAClC,gCAAgC;EAChC,kCAA0B;UAA1B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;;IAIE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;;IAKE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":[".destinations {\n  /* min-height: 200vh; */\n  /* padding-bottom: 7em; */\n}\n\n.destinations__result h2 {\n  font-size: 1.1rem;\n  color: var(--clr-gray800);\n  white-space: nowrap;\n}\n\n.destinations__resultContainer {\n  margin-top: 2rem;\n  display: grid;\n  gap: 1.5rem;\n  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n}\n\n.destinations__resultCard {\n  position: relative;\n  border-radius: 1em;\n  overflow: hidden;\n  height: 10rem;\n  cursor: pointer;\n\n  z-index: -1;\n  /* max-height: 20rem; */\n}\n\n.destinations__resultCard img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.destinations__titleResultCard {\n  position: absolute;\n  color: var(--clr-light);\n  background: var(--clr-primary);\n  padding: 1em;\n  font-size: 0.9rem;\n  letter-spacing: 0.075rem;\n  border-radius: 1em;\n  left: 1rem;\n  top: 1rem;\n}\n\n.destinations__priceResultCard {\n  display: flex;\n  align-items: center;\n  padding: 0.5em 1em;\n  position: absolute;\n  left: 1rem;\n  color: var(--clr-light);\n  bottom: 1rem;\n  border: 2px solid transparent;\n  -webkit-font-smoothing: antialiased;\n  background-clip: padding-box;\n  font-size: 0.9rem;\n  -moz-osx-font-smoothing: grayscale;\n  background: rgb(20, 20, 43, 0.4);\n  backdrop-filter: blur(5px);\n  letter-spacing: 0.075rem;\n  border-radius: 1em;\n}\n\n.destinations__priceResultCard img {\n  margin-right: 0.5rem;\n  display: block;\n  max-width: 1.5rem;\n}\n\n.destinations__resultBtn {\n  /* padding: 1em; */\n  margin: 3rem auto 0 auto;\n  border-radius: 1em;\n  padding: 1.25em 1.75em;\n}\n\n.destinations__resultBtn svg {\n  width: 1.5rem;\n  margin-right: 0.5rem;\n}\n\n@media (min-width: 375px) {\n  .destinations__result h2 {\n    font-size: 1.25rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .destinations__result {\n    padding-top: 5rem;\n  }\n\n  .destinations__resultCard {\n    height: 12rem;\n  }\n\n  .destinations__result h2 {\n    font-size: 2rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .destinations__resultCard:nth-of-type(11n + 7),\n  .destinations__resultCard:nth-of-type(11n + 6),\n  .destinations__resultCard:nth-of-type(11n + 3),\n  .destinations__resultCard:nth-of-type(11n + 2) {\n    grid-column: span 2;\n  }\n}\n\n@media (min-width: 1200px) {\n  .destinations__result {\n    padding-top: 2rem;\n  }\n\n  .destinations__resultCard {\n    height: 15rem;\n  }\n\n  .destinations__resultCard:nth-of-type(11n + 10),\n  .destinations__resultCard:nth-of-type(11n + 6),\n  .destinations__resultCard:nth-of-type(11n + 4),\n  .destinations__resultCard:nth-of-type(11n + 1),\n  .destinations__resultCard:nth-of-type(11n + 2) {\n    grid-column: span 2;\n  }\n\n  .destinations__resultCard:nth-of-type(11n + 3),\n  .destinations__resultCard:nth-of-type(11n + 7) {\n    grid-column: span 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
